import { useMemo } from 'react';
import { Theme } from '@mui/material/styles';
import { useAuth } from './useAuth';
import { createRoleTheme, getSidebarColors } from '../styles/roleThemes';
import { useUiSettings } from '../contexts/UiSettingsContext';
// Визначаємо тип ролі локально, оскільки UserRole не експортується
type UserRole = 'admin' | 'expert' | 'client';

export const useRoleTheme = () => {
  const { user } = useAuth();
  const { mode, fontScale } = useUiSettings();

  // Виправлення: додаємо type assertion для ролі
  const userRole = user?.roles?.[0] as UserRole | null || null;

  const theme: Theme = useMemo(() => {
    return createRoleTheme(userRole, mode, fontScale);
  }, [userRole, mode, fontScale]);

  const sidebarColors = useMemo(() => {
    return getSidebarColors(userRole);
  }, [userRole]);

  const roleDisplayName = useMemo(() => {
    switch (userRole) {
      case 'expert':
        return 'Експерт';
      case 'client':
        return 'Клієнт';
      case 'admin':
        return 'Адміністратор';
      default:
        return 'Користувач';
    }
  }, [userRole]);

  return {
    theme,
    userRole,
    sidebarColors,
    roleDisplayName,
  };
};